<template>
    <div class="area-content-body admin-list-contain">
        <div v-if="!canRead" class="no-permission-message">
            Sie haben keine Berechtigung, Listen zu öffnen.
        </div>

        <template v-else>
            <DxDataGrid class="admin-lists-grid"
                        :focused-row-enabled="true"
                        :auto-navigate-to-focused-row="autoNavigateToFocusedRow"
                        key-expr="_id"
                        v-if="loaded"
                        :data-source="lists"
                        v-model:selectedRowKeys="list"
                        @selection-changed="selectionChanged">
                <DxColumn data-field="name" caption="Liste" />
                <DxSelection mode="single" />
            </DxDataGrid>

            <div class="no-data-message" v-else>
                Listen werden geladen...
            </div>

            <router-view></router-view>
        </template>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import DxDataGrid, {
        DxColumn,
        DxSelection
    } from 'devextreme-vue/data-grid';
    import listApi from '../services/ListApi';
    import meApi from '../services/MeApi';
    import AppPermissions from '../constants/AppPermissions';

    export default defineComponent({
        components: {
            DxDataGrid,
            DxColumn,
            DxSelection
        },
        data() {
            return {
                lists: [],
                list: null,
                loaded: false
            };
        },
        computed: {
            canRead() {
                return meApi.hasPermissionSync(AppPermissions.AdminDropDowns.Read);
            },
            canWrite() {
                return meApi.hasPermissionSync(AppPermissions.AdminDropDowns.Write);
            },
            canDelete() {
                return meApi.hasPermissionSync(AppPermissions.AdminDropDowns.Delete);
            }
        },
        watch: {
            list() {
                if (this.list)
                    this.$router.push("/Admin/Lists/" + this.list)
            }
        },
        async created() {
            this.itemsGrid = null;

            if (!this.canRead)
                return;

            await this.fetchData();
        },
        methods: {
            async clearOne(listId) {
                if (!this.canDelete)
                    return;

                await listApi.delete(listId);
                this.items = await listApi.getListItems(listId);
                for (let item of this.items) {
                    await listApi.deleteItem(item._id);
                }
            },
            async fetchData() {
                if (!this.canRead)
                    return;

                this.loaded = false;

                this.lists = (await listApi.getAll())
                    .filter(l => !l.parentListItemId && !l.internalName.startsWith("sys_"));

                this.loaded = true;

                if (this.lists.length > 0) {
                    this.list = this.$route.params?.id || this.lists[0]._id;
                }
            },
            async selectionChanged(e) {
                this.list = e.selectedRowKeys[0];
            }
        },
    });
</script>

<style>
    .admin-list-contain {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-gap: 10px;
        grid-template-rows: minmax(0, 1fr);
    }

    .admin-lists-grid .dx-datagrid {
        padding: 10px;
        background-color: #2a2a2a;
    }

    .no-permission-message {
        padding: 20px;
        background-color: #2a2a2a;
    }
</style>